import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesStudentGPIStatsData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesEnrolmentStudentGPISlice = createSlice({
  name: "archiveServicesEnrolmentStudentGPI",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": 11,
            "location": "India",
           
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesStudentGPIStatsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesStudentGPIStatsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesStudentGPIStatsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesEnrolmentStudentGPISlice.reducer;